import { PowerBiReportDataVO } from '@repo/types/src/types/PowerBiReportDataVO'
import { PowerBiTokenVO } from '@repo/types/src/types/PowerBiTokenVO'
import { fetcher } from '../utils'

export default async (reportData: PowerBiReportDataVO): Promise<PowerBiTokenVO> => {
  return await fetcher(`/api/powerbi/access/token/${reportData?.reportId}/${reportData?.groupId}`, 'GET', undefined)
}
